import { isBrowser } from "../../../common/helpers/env";
import React from "react";
import styled from "styled-components";
import Loader from "../Loader";
import Wrapper from "../Task/Wrapper";

const StyledLoadingFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const LoadingFrame = () => (
    <div>
        <Wrapper>
            <StyledLoadingFrame
                style={{
                    transform: `scale(${(1.5 / (isBrowser ? window.innerWidth : 1200)) * 1200})`,
                }}
            >
                <Loader />
            </StyledLoadingFrame>
        </Wrapper>
    </div>
);

export default LoadingFrame;
